import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let default_1 = class extends Vue {
    fileName = '';
    devicesList = [
        {
            name: 'cs',
            deviceType: 'cs',
            id: 123,
        },
    ];
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    handelManual() {
        this.$confirm(this.$t('passManagement.tipMsg').toString(), this.$t('passManagement.toolTip').toString(), {
            confirmButtonText: this.$t('passManagement.confirm').toString(),
            cancelButtonText: this.$t('passManagement.cancel').toString(),
            type: 'warning',
        })
            .then(() => {
            //   this.$message({
            //     type: 'success',
            //     message: '删除成功!',
            //   });
        })
            .catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除',
            // });
        });
    }
    handleSizeChange() { }
    handleCurrentChange() { }
};
default_1 = __decorate([
    Component({
        components: {},
        i18n: {
            messages: {
                'en-us': {
                    son: 'Sub-device Name/Sub-device ID',
                },
                zh: {
                    son: '子设备名称/子设备ID',
                },
            },
        },
    })
], default_1);
export default default_1;
